import { Component, Input, OnChanges } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from 'src/app/shared/services/nav.service';
import { CommonModule } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-nav-item',
  standalone: true,
  imports: [TablerIconsModule, MaterialModule, CommonModule, AppNavItemComponent],
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent implements OnChanges {
  @Input() item: NavItem | any;
  @Input() depth: any;

  expanded = false;

  constructor(public navService: NavService, public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.children && this.item.children.length && url) {
        this.expanded = this.item.children.some(
          (child: NavItem) => child.route && url.includes(child.route)
        );
      }
    });
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
      document.querySelector('.page-wrapper')?.scroll({ top: 0, left: 0 });
      return;
    }
    this.expanded = !this.expanded;
  }
}
